import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import inflection from 'inflection';
import compose from 'recompose/compose';
import {withStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import {getResources, translate} from 'ra-core';
import DefaultIcon from '@material-ui/icons/ViewList';
import menuItems from '../security/resourceMenu';

import {Responsive, MenuItemLink, DashboardMenuItem, WithPermissions} from 'react-admin';

const styles = {
    main: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
    },
};


const translatedResourceName = (resource, translate) =>
    translate(`resources.${resource.name}.name`, {
        smart_count: 2,
        _:
            resource.options && resource.options.label
                ? translate(resource.options.label, {
                    smart_count: 2,
                    _: resource.options.label,
                })
                : inflection.humanize(inflection.pluralize(resource.name)),
    });
const Menu = ({
                  classes,
                  className,
                  dense,
                  hasDashboard,
                  onMenuClick,
                  open,
                  pathname,
                  resources,
                  translate,
                  logout,
                  ...rest
              }) => (
    <div className={classnames(classes.main, className)} {...rest}>
        {hasDashboard && <DashboardMenuItem onClick={onMenuClick}/>}
        {menuItems.map((item, index) => {
            if (item.name === 'divider') {
                return <WithPermissions
                    key={index}
                    render={({permissions}) => (
                        (permissions && (!item.roles || permissions.some(role => item.roles.includes(role)))) ?
                            <hr style={{marginRight: '8px', width: '100%'}} key={index}/>
                            :
                            null
                    )}/>
            }
            let resource = resources.find(({name}) => name === item.name);
            return (
                <WithPermissions
                    key={index}
                    render={({permissions}) => (
                        (resource && permissions && permissions.some(role => item.roles.includes(role)))
                            ? <MenuItemLink
                                to={`/${resource.name}`}
                                primaryText={translatedResourceName(resource, translate)}
                                leftIcon={
                                    resource.icon ? <resource.icon/> : <DefaultIcon/>
                                }
                                onClick={onMenuClick}
                                dense={dense}
                            />
                            : null
                    )}
                />
            )
        })}
        <Responsive xsmall={logout} medium={null}/>
    </div>
);

Menu.propTypes = {
    classes: PropTypes.object,
    className: PropTypes.string,
    dense: PropTypes.bool,
    hasDashboard: PropTypes.bool,
    logout: PropTypes.element,
    onMenuClick: PropTypes.func,
    open: PropTypes.bool,
    pathname: PropTypes.string,
    resources: PropTypes.array.isRequired,
    translate: PropTypes.func.isRequired,
};

Menu.defaultProps = {
    onMenuClick: () => null,
};

const mapStateToProps = state => ({
    open: state.admin.ui.sidebarOpen,
    resources: getResources(state),
    pathname: state.routing.location.pathname, // used to force redraw on navigation
});

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        {}, // Avoid connect passing dispatch in props,
        null,
        {
            areStatePropsEqual: (prev, next) =>
                prev.resources.every(
                    (value, index) => value === next.resources[index] // shallow compare resources
                ) &&
                prev.pathname === next.pathname &&
                prev.open === next.open,
        }
    ),
    withStyles(styles)
);

export default enhance(Menu);



// WEBPACK FOOTER //
// ./src/components/Menu.js